export default function() {
  return new Worker(__webpack_public_path__ + "reduceCanvasTo256Color.worker.1a41da4b55df3c3fe37e.worker.js");
}
